// extracted by mini-css-extract-plugin
export default {"yearSVG":"style-module--yearSVG--NH7P7"};